import {api} from '../../constants/api';
import axios from 'axios';

export const editCustomer = async (
  customerID,
  shumaID,
  firstName,
  lastName,
  phone,
  email,
  customerType,
  idNumber,
  genderID,
  address,
  status,
) => {
  const data = {
    customerID,
    shumaID,
    firstName,
    lastName,
    phone,
    email,
    customerType,
    idNumber,
    genderID,
    address,
    status,
  };
  const result = await axios.post(api.ADD_EDIT_CUSTOMER, data);
  return result.data;
};